import { render, staticRenderFns } from "./SubGroupCreateOrUpdate.vue?vue&type=template&id=818d5632&"
import script from "./SubGroupCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./SubGroupCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports